// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var CopyMarketingProfileLinkButton_urlDetails_graphql = require("../../__generated__/CopyMarketingProfileLinkButton_urlDetails_graphql.bs.js");

var convertFragment = CopyMarketingProfileLinkButton_urlDetails_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function baseUrlWithoutProtocol(url) {
  var baseUrl = Scalars.$$URL.toWebapiUrl(url);
  return baseUrl.host + baseUrl.pathname;
}

function CopyMarketingProfileLinkButton(props) {
  var match = use(props.urlDetails);
  var slug = match.slug;
  var baseUrl = baseUrlWithoutProtocol(match.baseUrl);
  var match$1 = React.useState(function () {
        return "Neutral";
      });
  var setState = match$1[1];
  var state = match$1[0];
  var timeoutRef = React.useRef(undefined);
  var copy = React.useCallback((function () {
          return window.navigator.clipboard.writeText(baseUrl + "/" + slug).then(function () {
                      setState(function (param) {
                            return "Confirming";
                          });
                      var timeoutId = setTimeout((function () {
                              setState(function (param) {
                                    return "Neutral";
                                  });
                            }), 2000);
                      timeoutRef.current = Caml_option.some(timeoutId);
                      return Promise.resolve();
                    });
        }), []);
  React.useEffect((function () {
          return (function () {
                    var timeoutId = timeoutRef.current;
                    if (timeoutId !== undefined) {
                      clearTimeout(Caml_option.valFromOption(timeoutId));
                      return ;
                    }
                    
                  });
        }), []);
  var tmp;
  tmp = state === "Neutral" ? JsxRuntime.jsx("div", {
          children: "Copy",
          className: "font-semibold text-gray-800 uppercase"
        }) : JsxRuntime.jsx("div", {
          children: "Copied!",
          className: "font-semibold text-green-800 uppercase"
        });
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(IconV5.make, {
                                    icon: "link",
                                    className: "text-gray-700 w-4 h-4"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      baseUrl + "/",
                                      JsxRuntime.jsx("wbr", {}),
                                      slug
                                    ],
                                    className: "text-gray-700"
                                  })
                            ],
                            className: "flex gap-4 items-center"
                          }),
                      tmp
                    ],
                    className: "flex justify-between items-center gap-4"
                  }),
              className: "border rounded-lg py-3 px-3 hover:bg-gray-100 w-full",
              onClick: (function (param) {
                  if (state === "Neutral") {
                    copy();
                    return ;
                  }
                  
                })
            });
}

var make = CopyMarketingProfileLinkButton;

exports.Fragment = Fragment;
exports.baseUrlWithoutProtocol = baseUrlWithoutProtocol;
exports.make = make;
/* react Not a pure module */
